import React from 'react';
import PropTypes from 'prop-types';
import { EuiText } from '@elastic/eui';
import { TranslateLanguage } from './KeywordTranslator';
import { parseScriptureReferenceList } from '../utils/scriptureReferences';
const ScriptureReferenceLinks = ({ value, language, onReferenceClick }) => {
  const items = parseScriptureReferenceList(value);
  if (!items.length) return null;

  return (
    <EuiText size="s" className="scripture-reference-list">
      <strong>{TranslateLanguage(language, '相關經文: ')}</strong>
      {items.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          {index > 0 && <span>, </span>}
          {item.reference ? (
            <button
              type="button"
              className="scripture-reference-link"
              onClick={() => onReferenceClick(item.reference)}
              aria-label={`${TranslateLanguage(language, '查看經文')} ${TranslateLanguage(language, item.label)}`}
            >
              {TranslateLanguage(language, item.label)}
            </button>
          ) : (
            <span>{TranslateLanguage(language, item.label)}</span>
          )}
        </React.Fragment>
      ))}
    </EuiText>
  );
};

ScriptureReferenceLinks.propTypes = {
  value: PropTypes.string,
  language: PropTypes.string.isRequired,
  onReferenceClick: PropTypes.func.isRequired,
};

ScriptureReferenceLinks.defaultProps = {
  value: '',
};

export default ScriptureReferenceLinks;